import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Form from "../../forms/Form";
import FormInput from "../../forms/FormInput";

import {
  timestampToTime,
  genOfferStatus,
  genVisibilityStatus,
  genStatusText,
} from "../../../utils/GeneralUtils";

import styles from "./Status.module.scss";
import { OfferStatus } from "../../../utils/OfferStatus";
import { PageVisibility } from "../../../utils/PageVisibility";

type Props = {
  isVisibilityStatus: boolean;
  status?: string;
  timestamp?: number;
  selectStatus?: string;

  showStatusMenu?: boolean;
  handleUpdateStatus?: () => void;
  handleStatusMenu?: () => void;
  setSelectStatus?: (value: string, name?: string) => void;
};

const Status: React.FC<Props> = ({
  isVisibilityStatus,
  status,
  timestamp,
  selectStatus,
  showStatusMenu,
  handleUpdateStatus,
  handleStatusMenu,
  setSelectStatus,
}) => {
  const statusColor = (status?: string) => {
    switch (status) {
      case OfferStatus.WaitingForInspection:
      case PageVisibility.AwaitingInspection:
        return "#dc3545";
      case OfferStatus.UndergoingInspection:
        return "#6f42c1";
      case OfferStatus.Complete:
      case PageVisibility.PubliclyVisible:
        return "#17a2b8";
      case OfferStatus.Cancelled:
      case PageVisibility.NotPubliclyVisible:
        return "#5f5f5f";
      case PageVisibility.DeletionRequest:
        return "#4b2d92";
    }
  };

  const offerListClass = () => {
    return [
      styles["pending"],
      styles["progress"],
      styles["complete"],
      styles["cancel"],
    ];
  };

  const visibilityListClass = () => {
    return [styles["awaiting"], styles["close"], styles["open"]];
  };

  const parentClass = isVisibilityStatus
    ? `${styles["f-adminOfferStatus"]} ${styles["visibility"]}`
    : `${styles["f-adminOfferStatus"]}`;

  return (
    <div className={parentClass}>
      <div className={styles["f-adminOfferStatus__title"]}>ステータス</div>
      <div className={styles["f-adminOfferStatus__status"]}>
        <div className={styles["f-adminOfferStatus__status-parent"]}>
          <div
            className={styles["f-adminOfferStatus__status-wrapper"]}
            style={{
              backgroundColor: statusColor(
                selectStatus ? selectStatus : status
              ),
            }}
          >
            {handleStatusMenu ? (
              <>
                <div
                  className={
                    styles["f-adminOfferStatus__status-wrapper__status"]
                  }
                >
                  {genStatusText(selectStatus ? selectStatus : status)}
                </div>
                <button
                  type="button"
                  className={styles["f-adminOfferStatus__status-wrapper__btn"]}
                  onClick={() => handleStatusMenu()}
                >
                  <FontAwesomeIcon icon={["fas", "chevron-down"]} />
                </button>
              </>
            ) : (
              <div
                className={`${styles["f-adminOfferStatus__status-wrapper__status"]} ${styles["jikei"]}`}
              >
                {genStatusText(status)}
              </div>
            )}
          </div>
          {handleStatusMenu && setSelectStatus && showStatusMenu === true ? (
            <div className={styles["f-adminOfferStatus__status-menu"]}>
              <div
                className={styles["f-adminOfferStatus__status-menu__header"]}
              >
                <span>ステータス変更</span>
                <FontAwesomeIcon
                  icon={["fas", "times"]}
                  onClick={() => handleStatusMenu()}
                />
              </div>
              <Form handler={() => {}} button_id="submitButton" button_text="">
                <FormInput
                  type="admin_offer_status"
                  label=""
                  label_class=""
                  id=""
                  name="sonic_status"
                  style_class={styles["f-adminOfferStatus__status-menu__type"]}
                  handler={(value, name) => {
                    if (value !== undefined && typeof value === "string") {
                      setSelectStatus(value, name);
                    }
                  }}
                  initial_value={status}
                  options={
                    isVisibilityStatus
                      ? genVisibilityStatus()
                      : genOfferStatus()
                  }
                  list_class={
                    isVisibilityStatus
                      ? visibilityListClass()
                      : offerListClass()
                  }
                ></FormInput>
                {!isVisibilityStatus ? (
                  <div className={styles["f-adminOfferStatus__status-save"]}>
                    <button
                      type="button"
                      className={styles["f-adminOfferStatus__status-save__btn"]}
                      onClick={handleUpdateStatus}
                    >
                      保存する
                    </button>
                  </div>
                ) : null}
              </Form>
            </div>
          ) : null}
        </div>
        <div className={styles["f-adminOfferStatus__status-info"]}>
          {timestamp ? (
            <>
              <div className={styles["f-adminOfferStatus__status-info__title"]}>
                申請日時
              </div>
              <div className={styles["f-adminOfferStatus__status-info__date"]}>
                {timestamp !== undefined
                  ? timestampToTime(timestamp, true)
                  : null}
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Status;
